import React from 'react';
import { Grid } from '@mui/material';
import { Colors } from '../utils/Colors';

export function CardContainer({ children }: any) {
  return (
    <Grid
      container
      direction="row"
      spacing={1}
      style={{
        border: `1px solid ${Colors.silverSand}`,
        borderRadius: '15px',
        padding: '15px'
      }}
      justifyContent="center"
    >
      {children}
    </Grid>
  );
}
